module.exports = __webpack_public_path__ + "img/sidebar-5.d88e9893.jpg";